(() => {
  const selector = [
    '[data-error]',
    '.form-notification.error',
    '.shopify-challenge__errors',
    '.product-form__error-message-wrapper',
    '.product-form__recipient-error-message-wrapper',
    '[role="alert"].error',
    '[role="alert"][class*="error-"]'
  ].join(',');

  function messageText(element) {
    return [...element.childNodes]
      .filter(node => !(node.nodeType === 1 && node.matches?.('.dc-error-close')))
      .map(node => node.textContent || '')
      .join('')
      .trim();
  }

  function dismiss(element) {
    if (element.matches('[data-error]')) {
      element.textContent = '';
      element.classList.remove('dc-dismissible-error');
      return;
    }
    element.dataset.dcDismissedError = messageText(element);
    element.hidden = true;
    element.setAttribute('aria-hidden', 'true');
  }

  function decorate(element) {
    if (!(element instanceof HTMLElement) || !element.matches(selector)) return;
    if (element.querySelector(selector)) return;
    const text = messageText(element);
    if (!text) return;
    if (element.dataset.dcDismissedError) {
      if (element.dataset.dcDismissedError === text) {
        element.hidden = true;
        return;
      }
      delete element.dataset.dcDismissedError;
      element.hidden = false;
      element.removeAttribute('aria-hidden');
    }
    if (element.querySelector(':scope > .dc-error-close')) return;
    element.classList.add('dc-dismissible-error');
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'dc-error-close';
    button.setAttribute('aria-label', 'Cerrar mensaje de error');
    button.textContent = '×';
    button.addEventListener('click', () => dismiss(element));
    element.append(button);
  }

  function scan(scope = document) {
    if (scope instanceof HTMLElement && scope.matches(selector)) decorate(scope);
    scope.querySelectorAll?.(selector).forEach(decorate);
  }

  function init() {
    scan();
    const observer = new MutationObserver(records => {
      records.forEach(record => {
        if (record.type === 'childList') {
          decorate(record.target instanceof HTMLElement ? record.target : record.target.parentElement);
          record.addedNodes.forEach(node => node.nodeType === 1 && scan(node));
        } else if (record.target instanceof HTMLElement) {
          decorate(record.target);
        }
      });
    });
    observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden', 'class', 'style'] });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
